import Layout from '@/components/layout';
import Image from 'next/image';
import BrandApplicationForm from '@/components/pages/brand-application/BrandApplicationForm';
import HowItWorksCard from '@/components/pages/membership/HowItWorksCard';
import { Pages } from '@/lib/seoData';
import { NextSSRPage, withServerSideProps } from 'hoc/withServerSideProps';

const discoverDailyPolishedData = [
  {
    headline: "Dedicated Audience",
    description: "Our members are beauty savvy and focused, ready and waiting to try the next big thing and fall in love with products.",
  },
  {
    headline: "Get Feedback",
    description: "Our members get incentives to share their genuine feedback about your products based on full-size experience.",
  },
  {
    headline: "Create Brand Loyalty",
    description: "Get your full-size product into the hands of the very consumers who are likely to keep coming back for more.",
  },
]

const BrandApplicationPage: NextSSRPage = (props) => {
  return (
    <Layout {...props}>
      <div className="flex flex-col justify-center items-center text-center p-8 lg:pt-24 lg:px-24 lg:pb-0">
        <div className="flex flex-col justify-center items-center">
          <div>
            <h1 className="mb-8 leading-[1em]">
              Be Discovered on Daily Polished
            </h1>
            <p className='mb-2 text-lg'>DAILY POLISHED IS THE ESSENTIAL DISCOVERY PLATFORM FOR BEAUTY AND LIFESTYLE BRANDS.</p>
            <p className="lg:mx-auto lg:px-0 xl:px-20 lg:w-3/4">
              Daily Polished is a luxurious members only discovery and retail platform for emerging beauty and lifestyle brands. Our daily brand drops create anticipation and excitement for beauty savvy members to visit Daily Polished - discover, learn and try new brands and products. Daily Polished features a complete takeover by only one brand to generate brand awareness through undivided attention and full size product experience. Our goal is to create curated experience without the noise.
            </p>
          </div>
        </div>
        <div className="container flex flex-col mx-auto justify-center pt-8 pb-4 lg:py-14">
          <div className="flex flex-col gap-8 lg:flex-row justify-center">
            {discoverDailyPolishedData.map((el, index) => <HowItWorksCard
              key={`${el.headline}-${index}`}
              headline={el.headline}
              description={el.description}
              hasBgc
            />)}
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-center mb-12">
        <Image
          alt={'arrow-down'}
          src={`/icons/arrow-down-silver.svg`}
          width={16}
          height={16}
        />
      </div>
      <div className="px-6 py-14 bg-cloud flex flex-col justify-center items-center">
        <h2 className="mb-6">Brand Application</h2>
        <p>Tell us more about your brand</p>
        <BrandApplicationForm />
      </div>
    </Layout>
  );
};

export const getServerSideProps = withServerSideProps(async function () {
  return { props: {} }
}, Pages.BRAND_APPLICATION)

export default BrandApplicationPage;
